import { PaymentViewLayout } from 'components/Layout/PaymentViewLayout';
import React, { Suspense } from 'react';

import { ApplicationStatusView } from '../onboarding/ApplicationStatusView';

export const PaymentsPage = () => (
  <PaymentViewLayout title="Payment Settings">
    <Suspense fallback={<div>Loading...</div>}>
      <div className="flex flex-col text-xmd gap-y-f2 p-f2">
        <ApplicationStatusView />
      </div>
    </Suspense>
  </PaymentViewLayout>
);
